import React, { useEffect, useState } from 'react';
import {
  Switch,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Hidden,
  IconButton,
  InputLabel,
  Menu,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Box,
  Card,
  CardContent,
  CardActions,
  Chip,
  Divider,
  Tooltip,
  Tabs,
  Tab,
  InputAdornment,
} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import TuneIcon from '@material-ui/icons/Tune';
import ServiceInputCalculatorModal from '../Common/ServiceInputCalculatorModal';
import LinkIcon from '@material-ui/icons/Link';
import DescriptionIcon from '@material-ui/icons/Description';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import { Autocomplete, createFilterOptions } from '@material-ui/lab';
import { Field, Form, Formik } from 'formik';
import CurrencyTextField from '@unicef/material-ui-currency-textfield/dist/CurrencyTextField';
import SearchIcon from '@material-ui/icons/Search';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import PrintIcon from '@material-ui/icons/Print';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme, makeStyles } from '@material-ui/core/styles';
import useApi from '../../../utils/useApi';
import { ProductSinglePrintModal, CategoryBulkPrintModal } from '../../Product/LabelPrint';
import UIBatchActionBar from '../../UI/BatchActionBar/UIBatchActionBar';

const useStyles = makeStyles((theme) => ({
  filterPaper: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderRadius: 8,
    boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
  },
  tableContainer: {
    borderRadius: 8,
    boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
  },
  tableHead: {
    backgroundColor: theme.palette.grey[50],
  },
  tableHeadCell: {
    fontWeight: 600,
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
  },
  actionBtn: {
    padding: 8,
  },
  dialogPaper: {
    borderRadius: 12,
    minHeight: 620,
    maxHeight: '90vh',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('xs')]: {
      margin: 0,
      width: '100%',
      height: '100%',
      minHeight: '100%',
      maxHeight: 'none',
      borderRadius: 0,
    },
  },
  dialogContentStable: {
    flex: 1,
    minHeight: 460,
    padding: theme.spacing(2.5, 3),
    overflowY: 'auto',
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2, 1.5),
      minHeight: 'auto',
    },
  },
  tabRoot: {
    minHeight: 52,
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '0.9rem',
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.75rem',
      padding: '6px 4px',
      minWidth: 'auto',
    },
  },
  metricCard: {
    padding: theme.spacing(2),
    borderRadius: 8,
    backgroundColor: '#f8fafc',
    border: '1px solid #e2e8f0',
    marginBottom: theme.spacing(2),
  },
  profitBadgePositive: {
    backgroundColor: '#e6f4ea',
    color: '#137333',
    fontWeight: 'bold',
    padding: '4px 10px',
    borderRadius: 16,
    display: 'inline-flex',
    alignItems: 'center',
    fontSize: '0.875rem',
  },
  profitBadgeNegative: {
    backgroundColor: '#fce8e6',
    color: '#c5221f',
    fontWeight: 'bold',
    padding: '4px 10px',
    borderRadius: 16,
    display: 'inline-flex',
    alignItems: 'center',
    fontSize: '0.875rem',
  },
  marginHigh: {
    color: '#137333',
    fontWeight: 'bold',
  },
  marginLow: {
    color: '#b06000',
    fontWeight: 'bold',
  },
}));
import validationSchema from './validationSchema';
import UIButtonSearch from '../../UI/Button/Search/Search';
import UIModalFilter from '../../UI/ModalFilter/UIModalFilter';
import UIContainer from '../../UI/Container/UIContainer';
import UIFormTitle from '../../UI/Form/Title/UIFormTitle';
import {
  emptyObject,
  capitalize,
  clearObject,
  formattedCurrency,
  isEqualObject,
  calculateMarkupByValue,
  calculateMarginByValue,
  calculateProfitByValue,
  calculateValueByMargin,
  parseImages,
  parseFractionOrNumber,
} from '../../../utils/utils';
import UIFilter from '../../UI/Button/Filter/UIFilter';
import UIDialogConfirm from '../../UI/Dialog/Confirm/UIDialogConfirm';
import UIDialogTitle from '../../UI/Dialog/Title/UIDialogTitle';
import UITablePagination from '../../UI/Table/Pagination/UITablePagination';
import SupplierCreateModal from '../../Supplier/SupplierCreateModal';
import UIImageUpload from '../../UI/ImageUpload/UIImageUpload';
import UIDuxiaDescriptionButton from '../../UI/Duxia/UIDuxiaDescriptionButton';
import UIBarcodeRegenerateButton from '../../UI/Barcode/UIBarcodeRegenerateButton';

const initialState = {
  id: '',
  name: '',
  description: '',
  category: '',
  particulars: '',
  value: '',
  barCode: '',
  supplier: '',
  isActive: true,
  showInCatalog: false,
  images: [],
};

const initialClick = {
  mouseX: null,
  mouseY: null,
};

const supplierFilter = createFilterOptions();

const ServiceSearch = (children) => {
  const { referenceId } = children;
  const classes = useStyles();

  // verificar se é mobile
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('sm'));

  // mensagem de confirmação para operações
  const [alert, setAlert] = useState(false);

  // modais de pesquisa e filtragem
  const [view, setView] = useState(!!referenceId);
  const [changeActive, setChangeActive] = useState(false);
  const [filter, setFilter] = useState(false);
  const [modalValues, setModalValues] = useState({});

  const [modalSupplier, setModalSupplier] = useState(false);
  const [newSupplierName, setNewSupplierName] = useState('');

  // salvar valores do form de pesquisa
  const [search, setSearch] = useState({ isActive: '1' });

  // paginação
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  // provider do click do lado direito
  const [clickRight, setClickRight] = useState(initialClick);
  const handleClickRight = (event, values) => {
    event.preventDefault();
    setModalValues({
      ...values,
      particulars: values.particulars,
      show_in_catalog: values.show_in_catalog === '1' || values.show_in_catalog === 1 || values.show_in_catalog === true,
      images: parseImages(values.images),
    });
    setClickRight({
      mouseX: event.clientX - 2,
      mouseY: event.clientY - 4,
    });
  };
  const handleCloseClickRight = () => {
    setClickRight(initialClick);
  };
  const [printSingleProduct, setPrintSingleProduct] = useState(null);
  const [bulkPrintModal, setBulkPrintModal] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [bulkPrintItems, setBulkPrintItems] = useState(null);
  // ação para click esquerdo
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClickLeft = (event, values) => {
    setModalValues({
      ...values,
      particulars: values.particulars,
      show_in_catalog: values.show_in_catalog === '1' || values.show_in_catalog === 1 || values.show_in_catalog === true,
      images: parseImages(values.images),
    });
    setAnchorEl(event.currentTarget);
  };

  const handleCloseClickLeft = () => {
    setAnchorEl(null);
  };

  // chamadas á API
  const [categoryLoad, categoryInfo] = useApi({
    method: 'get',
    url: '/services/categories',
  });

  const [suppliersLoad, suppliersInfo] = useApi({
    method: 'get',
    url: '/suppliers',
  });

  const [productsLoad, productsInfo] = useApi({
    method: 'get',
    url: '/products',
    params: { lacking: 0 },
  });

  const [servicesLoad, servicesInfo] = useApi({
    method: 'get',
    url: '/services',
    params: { isActive: '1' },
  });

  const [selectedProduct, setSelectedProduct] = useState(null);
  const [inputAmount, setInputAmount] = useState(1);
  const [calculatorOpen, setCalculatorOpen] = useState(false);
  const [calculatorItem, setCalculatorItem] = useState(null);
  const [editingInputIndex, setEditingInputIndex] = useState(null);

  const inputOptions = [
    ...(productsInfo.data || []).map(p => ({ ...p, inputType: 'P' })),
    ...(servicesInfo.data || []).map(s => ({ ...s, inputType: 'S' }))
  ].filter(item => !(item.inputType === 'S' && modalValues && item.id === modalValues.id));

  const [editingIndex, setEditingIndex] = useState(null);
  const [editingAmount, setEditingAmount] = useState(0);

  const getInputCost = (input) => {
    if (input.cost !== undefined && input.cost !== null) return parseFloat(input.cost);
    const option = inputOptions.find(i => (input.productId && i.inputType === 'P' && i.id === input.productId) || (input.inputServiceId && i.inputType === 'S' && i.id === input.inputServiceId));
    return parseFloat(option?.cost || 0);
  };

  const getInputValue = (input) => {
    if (input.value !== undefined && input.value !== null) return parseFloat(input.value);
    const option = inputOptions.find(i => (input.productId && i.inputType === 'P' && i.id === input.productId) || (input.inputServiceId && i.inputType === 'S' && i.id === input.inputServiceId));
    return parseFloat(option?.value || 0);
  };

  const getInputName = (input) => {
    if (input.name) return input.name;
    const option = inputOptions.find(i => (input.productId && i.inputType === 'P' && i.id === input.productId) || (input.inputServiceId && i.inputType === 'S' && i.id === input.inputServiceId));
    return option?.name || 'Item desconhecido';
  };

  const getInputType = (input) => {
    if (input.inputType) return input.inputType;
    if (input.inputServiceId) return 'S';
    return 'P';
  };

  const calculateTotalCost = (inputs) => {
    if (!inputs) return 0;
    return inputs.reduce((acc, curr) => acc + (getInputCost(curr) * parseFloat(curr.amount)), 0);
  };

  const calculateTotalPotentialGain = (inputs) => {
    if (!inputs) return 0;
    return inputs.reduce((acc, curr) => acc + (getInputValue(curr) * parseFloat(curr.amount)), 0);
  };

  const handleAddInput = (values, setFieldValue, amountToUse) => {
    const rawAmount = amountToUse !== undefined ? amountToUse : inputAmount;
    const parsed = parseFractionOrNumber(rawAmount);
    if (selectedProduct && parsed > 0) {
      const newInputs = [
        ...values.inputs,
        {
          productId: selectedProduct.inputType === 'P' ? selectedProduct.id : null,
          inputServiceId: selectedProduct.inputType === 'S' ? selectedProduct.id : null,
          name: selectedProduct.name,
          cost: parseFloat(selectedProduct.cost || 0),
          value: parseFloat(selectedProduct.value || 0),
          amount: parsed,
          inputType: selectedProduct.inputType,
        },
      ];
      setFieldValue('inputs', newInputs);
      setSelectedProduct(null);
      setInputAmount(1);
    }
  };

  const handleOpenEditInputModal = (index, input) => {
    const option = inputOptions.find(i => 
      (input.productId && i.inputType === 'P' && i.id === input.productId) || 
      (input.inputServiceId && i.inputType === 'S' && i.id === input.inputServiceId)
    );
    setEditingInputIndex(index);
    setCalculatorItem(option || {
      name: input.name,
      cost: input.cost,
      value: input.value,
      unit: input.unit || '',
      amount: input.amount,
      inputType: input.inputType,
    });
    setCalculatorOpen(true);
  };

  const handleOpenAddCalculator = () => {
    setEditingInputIndex(null);
    setCalculatorItem(selectedProduct);
    setCalculatorOpen(true);
  };

  const handleApplyCalculator = (calculatedValue, values, setFieldValue) => {
    const parsedAmount = parseFractionOrNumber(calculatedValue);
    if (parsedAmount <= 0) return;

    if (editingInputIndex !== null && editingInputIndex !== undefined) {
      const newInputs = values.inputs.map((item, i) =>
        i === editingInputIndex ? { ...item, amount: parsedAmount } : item
      );
      setFieldValue('inputs', newInputs);
      setEditingInputIndex(null);
      setCalculatorItem(null);
    } else {
      handleAddInput(values, setFieldValue, calculatedValue);
    }
  };

  const [filterLoad, filterInfo] = useApi({
    debounceDelay: 500,
    method: 'get',
    url: '/services',
    params: { isActive: '1' },
  });

  const [updateLoad, updateInfo, setUpdateInfo] = useApi({
    method: 'put',
    url: '/services',
    onCompleted: (response) => {
      if (response) {
        filterLoad({
          params: search,
        });
      }
    },
  });

  const [activeLoad, activeInfo, setActiveInfo] = useApi({
    method: 'patch',
    url: '/services',
  });

  const currentPageItems = (filterInfo.data || []).slice(
    page * rowsPerPage,
    rowsPerPage === -1 ? undefined : page * rowsPerPage + rowsPerPage,
  );
  const isAllPageSelected =
    currentPageItems.length > 0 &&
    currentPageItems.every((s) => selectedIds.includes(s.id));
  const isSomePageSelected =
    currentPageItems.some((s) => selectedIds.includes(s.id)) && !isAllPageSelected;

  const handleToggleSelect = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id],
    );
  };

  const handleSelectAll = () => {
    if (!filterInfo.data) return;
    const allIds = filterInfo.data.map((s) => s.id);
    if (selectedIds.length === allIds.length) {
      setSelectedIds([]);
    } else {
      setSelectedIds(allIds);
    }
  };

  const handleToggleSelectPage = () => {
    const pageIds = currentPageItems.map((s) => s.id);
    if (isAllPageSelected) {
      setSelectedIds((prev) => prev.filter((id) => !pageIds.includes(id)));
    } else {
      setSelectedIds((prev) => Array.from(new Set([...prev, ...pageIds])));
    }
  };

  const handleBatchCatalogVisibility = (show) => {
    if (!filterInfo.data || selectedIds.length === 0) return;
    const selectedServices = filterInfo.data.filter((s) =>
      selectedIds.includes(s.id),
    );
    const updatePayload = selectedServices.map((service) => ({
      id: service.id,
      name: service.name,
      description: service.description,
      barCode: service.barCode,
      category: Number(service.category),
      particulars: service.particulars,
      value: service.value,
      supplier: service.supplier?.id || service.supplier,
      isActive: Number(service.isActive),
      show_in_catalog: show,
      images: service.images || [],
    }));

    updateLoad({
      data: updatePayload,
      onCompleted: (response) => {
        if (response) {
          filterLoad({
            params: search,
          });
          setSelectedIds([]);
        }
      },
    });
    setAlert(true);
  };

  const handleBatchPrintLabels = () => {
    if (!filterInfo.data || selectedIds.length === 0) return;
    const selectedServices = filterInfo.data.filter((s) =>
      selectedIds.includes(s.id),
    );
    setBulkPrintItems(selectedServices);
    setBulkPrintModal(true);
  };

  const handleBatchDeactivate = () => {
    if (!filterInfo.data || selectedIds.length === 0) return;
    const deactPayload = selectedIds.map((id) => ({
      id,
    }));

    activeLoad({
      data: deactPayload,
      onCompleted: (res) => {
        if (res) {
          filterLoad({
            params: search,
          });
          setSelectedIds([]);
        }
      },
    });
    setAlert(true);
  };

  useEffect(() => {
    if (referenceId) initialState.id = referenceId;
    const params = referenceId ? { id: referenceId } : { isActive: '1' };
    filterLoad({
      params,
      onCompleted: (res) => {
        if (res && referenceId) {
          const [data] = res.data;
          setModalValues({
            ...data,
            particulars: data.particulars,
          });
        }
      },
    });
    suppliersLoad();
    categoryLoad();
    productsLoad();
    servicesLoad();
  }, []);

  function handleModalFilter() {
    setFilter(!filter);
  }

  const [modalTab, setModalTab] = useState(0);

  function handleModalUpdate(values, isClick, initialTab = 0) {
    if (values) {
      const valuesTreated = {
        ...values,
        isActive: values.isActive === '1' && true,
        particulars: values.particulars,
        show_in_catalog: values.show_in_catalog === '1' || values.show_in_catalog === 1 || values.show_in_catalog === true,
        images: parseImages(values.images),
      };
      setModalValues(valuesTreated);
    }
    setModalTab(initialTab);
    setSelectedProduct(null);
    setInputAmount(1);
    setEditingIndex(null);
    setEditingAmount(0);
    if (isClick) {
      const closeMenu = mobile ? handleCloseClickLeft : handleCloseClickRight;
      closeMenu();
    }
    setView(!view);
  }

  function handleModalActive(values, isClick) {
    if (values) {
      setModalValues(values);
    }
    if (isClick) {
      const closeMenu = mobile ? handleCloseClickLeft : handleCloseClickRight;
      closeMenu();
    }
    setChangeActive(!changeActive);
  }

  function closeAlert(event, reason) {
    setUpdateInfo();
    if (reason === 'clickaway') {
      return;
    }
    setAlert(false);
  }

  function onSearch(values) {
    const searchValues = {
      ...values,
      isActive: values.isActive === true || values.isActive === '1' ? '1' : '0',
    };
    if (values.showInCatalog) {
      searchValues.show_in_catalog = 1;
    } else {
      delete searchValues.show_in_catalog;
    }
    delete searchValues.showInCatalog;
    filterLoad({
      debounced: true,
      params: emptyObject(searchValues),
    });
    setSearch(emptyObject(searchValues));
    setPage(0);
  }

  function onActive() {
    const data = { id: modalValues?.id };
    activeLoad({
      data,
      onCompleted: (res) => {
        if (res) {
          filterLoad({
            params: search,
          });
        }
      },
    });
    setAlert(true);
    setChangeActive(false);
  }

  function onUpdate(values) {
    const updateValues = {
      id: values.id,
      name: values.name,
      description: values.description,
      barCode: values.barCode,
      category: Number(values.category),
      particulars: values.particulars,
      value: values.value,
      supplier: values.supplier.id || values.supplier, // Garante que pegue o ID
      show_in_catalog: Boolean(values.show_in_catalog),
      images: values.images || [],
      inputs: values.inputs.map((i) => {
        const item = { amount: i.amount };
        if (i.productId) item.productId = i.productId;
        if (i.inputServiceId) item.inputServiceId = i.inputServiceId;
        return item;
      }),
    };
    updateLoad({
      data: updateValues,
    });
    setView(!view);
    setAlert(true);
  }

  const toggleServiceCatalog = (service) => {
    if (!service) return;
    const isCatalog = service.show_in_catalog === '1' || service.show_in_catalog === 1 || service.show_in_catalog === true;
    const updateValues = {
      id: service.id,
      name: service.name,
      barCode: service.barCode,
      category: Number(service.category),
      particulars: service.particulars,
      value: service.value,
      supplier: service.supplier?.id || service.supplier,
      show_in_catalog: !isCatalog,
      inputs: (service.inputs || []).map((i) => {
        const item = { amount: i.amount };
        if (i.productId) item.productId = i.productId;
        if (i.inputServiceId) item.inputServiceId = i.inputServiceId;
        return item;
      }),
    };
    updateLoad({
      data: updateValues,
      onCompleted: (response) => {
        if (response) {
          filterLoad({
            params: search,
          });
        }
      },
    });
    setAlert(true);
  };

  return (
    <>
      <Formik onSubmit={onSearch} initialValues={initialState}>
        {({ values, submitForm, setFieldValue }) => (
          <Form onChange={() => submitForm()}>
            <UIContainer container direction="row">
              <Grid
                item
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                xs={12}
                style={{ marginBottom: 16 }}
              >
                <UIFormTitle title="Filtrar serviços" />
                <Box display="flex" alignItems="center">
                  <Button
                    variant="contained"
                    color="default"
                    startIcon={<PrintIcon />}
                    onClick={() => setBulkPrintModal(true)}
                  >
                    Imprimir Etiquetas
                  </Button>
                </Box>
              </Grid>

              <Grid item xs={12}>
                <Paper className={classes.filterPaper} elevation={0} variant="outlined">
                  <Grid container spacing={2} alignItems="center">
                    <Hidden smDown>
                      <Grid item xs={12} md={1}>
                        <Field
                          name="id"
                          label="ID"
                          placeholder="ID"
                          variant="outlined"
                          size="small"
                          fullWidth
                          as={TextField}
                        />
                      </Grid>
                    </Hidden>
                    <Grid item xs={6} md={3}>
                      <Field
                        name="name"
                        label="Nome"
                        placeholder="Nome do serviço"
                        variant="outlined"
                        size="small"
                        fullWidth
                        as={TextField}
                      />
                    </Grid>
                    <Grid item xs={6} md={3}>
                      <Autocomplete
                        clearOnEscape
                        noOptionsText="Sem opções"
                        disabled={categoryInfo.loading}
                        options={categoryInfo.data !== null ? categoryInfo.data : []}
                        getOptionSelected={(category) => category.name}
                        getOptionLabel={(category) => category.name}
                        onChange={(event, category) => {
                          setFieldValue('category', category && category.id);
                          submitForm();
                        }}
                        renderInput={(params) => (
                          <Field
                            {...params}
                            label="Categoria"
                            name="category"
                            variant="outlined"
                            size="small"
                            placeholder="Categoria do serviço"
                            component={TextField}
                          />
                        )}
                      />
                    </Grid>
                    <Hidden smDown>
                      <Grid item xs={12} md={2}>
                        <Field
                          name="barCode"
                          label="Código serviço"
                          placeholder="Código do serviço"
                          variant="outlined"
                          size="small"
                          fullWidth
                          as={TextField}
                        />
                      </Grid>
                    </Hidden>
                    <Hidden smDown>
                      <Grid item xs={12} md={2}>
                        <CurrencyTextField
                          type="tel"
                          value={values.value}
                          label="Valor de venda"
                          variant="outlined"
                          size="small"
                          decimalCharacter=","
                          digitGroupSeparator="."
                          currencySymbol="R$"
                          outputFormat="string"
                          onChange={(ev, value) => setFieldValue('value', value)}
                          fullWidth
                        />
                      </Grid>
                    </Hidden>
                    <Hidden smDown>
                      <Grid item xs={12} md={1}>
                        <UIButtonSearch xs={12} />
                      </Grid>
                    </Hidden>
                  </Grid>

                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    flexWrap="wrap"
                    style={{ marginTop: 10 }}
                  >
                    <Hidden smDown>
                      <Box display="flex" alignItems="center">
                        <FormControlLabel
                          control={
                            <Checkbox
                              color="primary"
                              checked={Boolean(values.showInCatalog)}
                              onChange={(ev) => {
                                ev.stopPropagation();
                                const checked = ev.target.checked;
                                setFieldValue('showInCatalog', checked);
                                onSearch({
                                  ...values,
                                  showInCatalog: checked,
                                });
                              }}
                            />
                          }
                          label="Somente itens do catálogo"
                        />
                        <FormControlLabel
                          control={
                            <Switch
                              color="primary"
                              checked={Boolean(values.isActive === true || values.isActive === '1' || values.isActive === 1)}
                              onChange={(ev) => {
                                ev.stopPropagation();
                                const checked = ev.target.checked;
                                setFieldValue('isActive', checked);
                                onSearch({
                                  ...values,
                                  isActive: checked,
                                });
                              }}
                            />
                          }
                          label={
                            (values.isActive === true || values.isActive === '1' || values.isActive === 1)
                              ? 'Disponível: Sim'
                              : 'Disponível: Não'
                          }
                        />
                      </Box>
                    </Hidden>

                    <Box display="flex" alignItems="center" justifyContent="flex-end" style={{ marginLeft: 'auto', padding: '4px 0' }}>
                      <UIFilter onClick={handleModalFilter} />
                    </Box>
                  </Box>
                </Paper>
              </Grid>
            </UIContainer>

            <UIModalFilter
              open={filter}
              changeModal={handleModalFilter}
              submit={submitForm}
            >
              <Hidden mdUp>
                <Grid item xs={12}>
                  <Field
                    name="id"
                    label="ID"
                    placeholder="ID"
                    fullWidth
                    as={TextField}
                  />
                </Grid>
              </Hidden>
              <Grid item xs={12}>
                <Autocomplete
                  clearOnEscape
                  noOptionsText="Sem opções"
                  value={values.supplier}
                  disabled={suppliersInfo.loading}
                  options={
                    suppliersInfo.data !== null ? suppliersInfo.data : []
                  }
                  getOptionLabel={(supplier) => supplier.name}
                  onChange={(event, supplier) => {
                    setFieldValue('supplier', supplier);
                  }}
                  renderInput={(params) => (
                    <Field
                      {...params}
                      label="Fornecedor"
                      name="supplier"
                      variant="standard"
                      placeholder="Informe o fornecedor do serviço"
                      component={TextField}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <Field
                  name="particulars"
                  label="Caracteristica do serviço"
                  placeholder="Informe a caracteristica do serviço"
                  fullWidth
                  as={TextField}
                />
              </Grid>
              <Hidden mdUp>
                <Grid item xs={12}>
                  <Field
                    name="barCode"
                    label="Código serviço"
                    placeholder="Código do serviço"
                    fullWidth
                    as={TextField}
                  />
                </Grid>
              </Hidden>
              <Hidden mdUp>
                <Grid item xs={12}>
                  <CurrencyTextField
                    type="tel"
                    value={values.value}
                    label="Valor de venda"
                    variant="standard"
                    decimalCharacter=","
                    digitGroupSeparator="."
                    currencySymbol="R$"
                    outputFormat="string"
                    onChange={(ev, value) => setFieldValue('value', value)}
                    fullWidth
                  />
                </Grid>
              </Hidden>
              <Hidden mdUp>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        color="primary"
                        checked={Boolean(values.showInCatalog)}
                        onChange={(ev) =>
                          setFieldValue('showInCatalog', ev.target.checked)
                        }
                      />
                    }
                    label="Somente itens do catálogo"
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={Boolean(values.isActive === true || values.isActive === '1' || values.isActive === 1)}
                        onChange={(ev) =>
                          setFieldValue('isActive', ev.target.checked)
                        }
                      />
                    }
                    label={
                      (values.isActive === true || values.isActive === '1' || values.isActive === 1)
                        ? 'Disponível: Sim'
                        : 'Disponível: Não'
                    }
                  />
                </Grid>
              </Hidden>
            </UIModalFilter>
          </Form>
        )}
      </Formik>
      <UIContainer>
        <Grid item xs={12}>
          <UIFormTitle title="Lista de serviços" />
        </Grid>
        <Grid item xs={12}>
          {/* Tabela Desktop */}
          <Hidden smDown>
            <TableContainer component={Paper} className={classes.tableContainer}>
              <Table>
                <TableHead className={classes.tableHead}>
                  <TableRow>
                    <TableCell padding="checkbox" className={classes.tableHeadCell}>
                      <Checkbox
                        indeterminate={isSomePageSelected}
                        checked={isAllPageSelected}
                        onChange={handleToggleSelectPage}
                        color="primary"
                        size="small"
                      />
                    </TableCell>
                    <TableCell className={classes.tableHeadCell}>ID</TableCell>
                    <TableCell className={classes.tableHeadCell}>Nome</TableCell>
                    <TableCell className={classes.tableHeadCell}>Categoria</TableCell>
                    <TableCell className={classes.tableHeadCell}>Custo</TableCell>
                    <TableCell className={classes.tableHeadCell}>Venda</TableCell>
                    <TableCell className={classes.tableHeadCell}>Markup</TableCell>
                    <TableCell className={classes.tableHeadCell}>Margem</TableCell>
                    <TableCell className={classes.tableHeadCell} align="right">Ações</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filterInfo.loading && (
                    <TableRow>
                      <TableCell colSpan={9} align="center">
                        <CircularProgress />
                      </TableCell>
                    </TableRow>
                  )}
                  {filterInfo.data &&
                    categoryInfo.data &&
                    filterInfo.data
                      .slice(
                        page * rowsPerPage,
                        rowsPerPage === -1
                          ? undefined
                          : page * rowsPerPage + rowsPerPage,
                      )
                      .map((data) => (
                        <TableRow
                          onDoubleClick={() => handleModalUpdate(data)}
                          onContextMenu={
                            !mobile
                              ? (ev) => handleClickRight(ev, data)
                              : undefined
                          }
                          style={{ cursor: 'context-menu' }}
                          onClick={
                            mobile ? (ev) => handleClickLeft(ev, data) : undefined
                          }
                          hover
                          key={data.id}
                        >
                          <TableCell padding="checkbox" onClick={(e) => e.stopPropagation()}>
                            <Checkbox
                              checked={selectedIds.includes(data.id)}
                              onChange={() => handleToggleSelect(data.id)}
                              color="primary"
                              size="small"
                            />
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {data.id}
                          </TableCell>
                          <TableCell>
                            <Box display="flex" alignItems="center" style={{ gap: 6 }}>
                              <span>{data.name}</span>
                              {parseFloat(data.cost) > 0 && (
                                <Tooltip title="Pode ser usado como insumo em outros serviços">
                                  <LinkIcon
                                    style={{
                                      fontSize: 15,
                                      color: '#17497F',
                                      opacity: 0.7,
                                      flexShrink: 0,
                                    }}
                                  />
                                </Tooltip>
                              )}
                            </Box>
                          </TableCell>
                          <TableCell>
                            {
                              categoryInfo.data.find(
                                (item) => item.id === data.category,
                              )?.name || 'Sem categoria'
                            }
                          </TableCell>
                          <TableCell>{formattedCurrency(data.cost)}</TableCell>
                          <TableCell>{formattedCurrency(data.value)}</TableCell>
                          <TableCell>{calculateMarkupByValue(data.cost, data.value)} %</TableCell>
                          <TableCell>
                            <Typography
                              variant="body2"
                              style={{
                                color: parseFloat(calculateMarginByValue(data.cost, data.value)) > 20 ? 'green' : 'orange',
                                fontWeight: 'bold'
                              }}
                            >
                              {calculateMarginByValue(data.cost, data.value)} %
                            </Typography>
                          </TableCell>
                          <TableCell align="right">
                            <Switch
                              title={
                                Number(data.isActive) === 1
                                  ? 'Desativar serviço'
                                  : 'Ativar serviço'
                              }
                              onClick={() => handleModalActive(data)}
                              color="primary"
                              checked={Number(data.isActive) === 1}
                            />
                            <Tooltip title={data.show_in_catalog === '1' || data.show_in_catalog === 1 || data.show_in_catalog === true ? "Remover do Catálogo Virtual" : "Exibir no Catálogo Virtual"}>
                              <IconButton
                                onClick={() => toggleServiceCatalog(data)}
                                size="small"
                              >
                                {data.show_in_catalog === '1' || data.show_in_catalog === 1 || data.show_in_catalog === true ? (
                                  <VisibilityIcon fontSize="small" style={{ color: '#17497F' }} />
                                ) : (
                                  <VisibilityOffIcon fontSize="small" style={{ color: '#9E9E9E' }} />
                                )}
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Editar Serviço">
                              <IconButton
                                onClick={() => handleModalUpdate(data)}
                                size="small"
                              >
                                <EditIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Imprimir Etiqueta">
                              <IconButton
                                onClick={() => setPrintSingleProduct(data)}
                                size="small"
                              >
                                <PrintIcon fontSize="small" style={{ color: '#17497F' }} />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      ))}
                  <Menu
                    keepMounted
                    open={clickRight.mouseY !== null}
                    onClose={handleCloseClickRight}
                    anchorReference="anchorPosition"
                    anchorPosition={
                      clickRight.mouseY !== null && clickRight.mouseX !== null
                        ? {
                          top: clickRight.mouseY,
                          left: clickRight.mouseX,
                        }
                        : undefined
                    }
                  >
                    <MenuItem onClick={() => { toggleServiceCatalog(modalValues); handleCloseClickRight(); }}>
                      {modalValues?.show_in_catalog ? (
                        <><VisibilityOffIcon fontSize="small" style={{ marginRight: 10 }} /> Remover do Catálogo</>
                      ) : (
                        <><VisibilityIcon fontSize="small" style={{ marginRight: 10 }} /> Exibir no Catálogo</>
                      )}
                    </MenuItem>
                    <MenuItem onClick={() => handleModalUpdate(null, true, 0)}>
                      <DescriptionIcon fontSize="small" style={{ marginRight: 10 }} /> Dados do Serviço
                    </MenuItem>
                    <MenuItem onClick={() => handleModalUpdate(null, true, 1)}>
                      <MonetizationOnIcon fontSize="small" style={{ marginRight: 10 }} /> Preço & Rentabilidade
                    </MenuItem>
                    <MenuItem onClick={() => handleModalUpdate(null, true, 2)}>
                      <LinkIcon fontSize="small" style={{ marginRight: 10 }} /> Composição de Insumos
                    </MenuItem>
                    <Divider />
                    <MenuItem onClick={() => handleModalActive(null, true)}>
                      {Number(modalValues?.isActive) === 1
                        ? 'Desativar serviço'
                        : 'Ativar serviço'}
                    </MenuItem>
                  </Menu>
                  <Menu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={() => handleCloseClickLeft()}
                  >
                    <MenuItem onClick={() => { toggleServiceCatalog(modalValues); handleCloseClickLeft(); }}>
                      {modalValues?.show_in_catalog ? (
                        <><VisibilityOffIcon fontSize="small" style={{ marginRight: 10 }} /> Remover do Catálogo</>
                      ) : (
                        <><VisibilityIcon fontSize="small" style={{ marginRight: 10 }} /> Exibir no Catálogo</>
                      )}
                    </MenuItem>
                    <MenuItem onClick={() => handleModalUpdate(null, true, 0)}>
                      <DescriptionIcon fontSize="small" style={{ marginRight: 10 }} /> Dados do Serviço
                    </MenuItem>
                    <MenuItem onClick={() => handleModalUpdate(null, true, 1)}>
                      <MonetizationOnIcon fontSize="small" style={{ marginRight: 10 }} /> Preço & Rentabilidade
                    </MenuItem>
                    <MenuItem onClick={() => handleModalUpdate(null, true, 2)}>
                      <LinkIcon fontSize="small" style={{ marginRight: 10 }} /> Composição de Insumos
                    </MenuItem>
                    <Divider />
                    <MenuItem onClick={() => handleModalActive(null, true)}>
                      {Number(modalValues?.isActive) === 1
                        ? 'Desativar serviço'
                        : 'Ativar serviço'}
                    </MenuItem>
                  </Menu>
                  {filterInfo.error && (
                    <TableRow>
                      <TableCell colSpan={8}>Sem resultados encontrados</TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
              <UITablePagination
                count={filterInfo.data ? filterInfo.data.length : 0}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
              />
            </TableContainer>
          </Hidden>

          {/* Listagem em Cards Mobile */}
          <Hidden mdUp>
            <Box style={{ width: '100%' }}>
              {filterInfo.data && filterInfo.data.length > 0 && (
                <Box display="flex" alignItems="center" justifyContent="space-between" mb={1} px={0.5}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        indeterminate={isSomePageSelected}
                        checked={isAllPageSelected}
                        onChange={handleToggleSelectPage}
                        color="primary"
                        size="small"
                      />
                    }
                    label={
                      <Typography variant="caption" style={{ fontWeight: 600 }}>
                        Selecionar página
                      </Typography>
                    }
                  />
                </Box>
              )}
              {filterInfo.loading && (
                <CircularProgress style={{ margin: '16px auto', display: 'block' }} />
              )}
              {filterInfo.data &&
                categoryInfo.data &&
                filterInfo.data
                  .slice(
                    page * rowsPerPage,
                    rowsPerPage === -1
                      ? undefined
                      : page * rowsPerPage + rowsPerPage,
                  )
                  .map((data) => {
                    const isActive = Number(data.isActive) === 1;
                    const categoryName = categoryInfo.data.find(
                      (item) => item.id === data.category,
                    )?.name || 'Sem categoria';
                    const marginValue = parseFloat(
                      calculateMarginByValue(data.cost, data.value),
                    );

                    return (
                      <Card
                        key={data.id}
                        variant="outlined"
                        style={{
                          marginBottom: 12,
                          borderLeft: `4px solid ${isActive ? '#17497F' : '#9E9E9E'}`,
                          borderRadius: 8,
                          backgroundColor: isActive ? '#FFFFFF' : '#FAFAFA',
                        }}
                      >
                        <CardContent style={{ paddingBottom: 8 }}>
                          <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            mb={1}
                          >
                            <Box display="flex" alignItems="center" style={{ gap: 4 }}>
                              <Checkbox
                                checked={selectedIds.includes(data.id)}
                                onChange={() => handleToggleSelect(data.id)}
                                color="primary"
                                size="small"
                                style={{ padding: 4 }}
                              />
                              <Typography
                                variant="subtitle1"
                                style={{ fontWeight: 'bold' }}
                              >
                                #{data.id} - {data.name}
                              </Typography>
                            </Box>
                            <Box display="flex" alignItems="center" style={{ gap: 4 }}>
                              <Chip
                                label={isActive ? 'Ativo' : 'Inativo'}
                                size="small"
                                style={{
                                  backgroundColor: isActive ? '#17497F' : '#9E9E9E',
                                  color: '#fff',
                                  fontWeight: 'bold',
                                }}
                              />
                              {parseFloat(data.cost) > 0 && (
                                <Tooltip title="Pode ser usado como insumo em outros serviços">
                                  <LinkIcon style={{ fontSize: 16, color: '#17497F', opacity: 0.7 }} />
                                </Tooltip>
                              )}
                            </Box>
                          </Box>
                          <Divider style={{ margin: '8px 0' }} />
                          <Grid container spacing={1}>
                            <Grid item xs={6}>
                              <Typography
                                variant="caption"
                                color="textSecondary"
                                display="block"
                              >
                                Categoria
                              </Typography>
                              <Typography variant="body2">{categoryName}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                              <Typography
                                variant="caption"
                                color="textSecondary"
                                display="block"
                              >
                                Custo
                              </Typography>
                              <Typography variant="body2">
                                {formattedCurrency(data.cost)}
                              </Typography>
                            </Grid>
                            <Grid item xs={6}>
                              <Typography
                                variant="caption"
                                color="textSecondary"
                                display="block"
                              >
                                Venda
                              </Typography>
                              <Typography variant="body2">
                                {formattedCurrency(data.value)}
                              </Typography>
                            </Grid>
                            <Grid item xs={3}>
                              <Typography
                                variant="caption"
                                color="textSecondary"
                                display="block"
                              >
                                Markup
                              </Typography>
                              <Typography variant="body2">
                                {calculateMarkupByValue(data.cost, data.value)}%
                              </Typography>
                            </Grid>
                            <Grid item xs={3}>
                              <Typography
                                variant="caption"
                                color="textSecondary"
                                display="block"
                              >
                                Margem
                              </Typography>
                              <Typography
                                variant="body2"
                                style={{
                                  color: marginValue > 20 ? 'green' : 'orange',
                                  fontWeight: 'bold',
                                }}
                              >
                                {calculateMarginByValue(data.cost, data.value)}%
                              </Typography>
                            </Grid>
                          </Grid>
                        </CardContent>
                        <CardActions
                          style={{
                            justifyContent: 'flex-end',
                            paddingTop: 0,
                            paddingRight: 16,
                            paddingBottom: 8,
                          }}
                        >
                          <Switch
                            title={isActive ? 'Desativar serviço' : 'Ativar serviço'}
                            onClick={() => handleModalActive(data)}
                            color="primary"
                            checked={isActive}
                          />
                          <Tooltip title={data.show_in_catalog === '1' || data.show_in_catalog === 1 || data.show_in_catalog === true ? "Remover do Catálogo Virtual" : "Exibir no Catálogo Virtual"}>
                            <IconButton
                              onClick={() => toggleServiceCatalog(data)}
                              size="small"
                            >
                              {data.show_in_catalog === '1' || data.show_in_catalog === 1 || data.show_in_catalog === true ? (
                                <VisibilityIcon fontSize="small" style={{ color: '#17497F' }} />
                              ) : (
                                <VisibilityOffIcon fontSize="small" style={{ color: '#9E9E9E' }} />
                              )}
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Editar Serviço">
                            <IconButton
                              onClick={() => handleModalUpdate(data)}
                              size="small"
                            >
                              <EditIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Imprimir Etiqueta">
                            <IconButton
                              onClick={() => setPrintSingleProduct(data)}
                              size="small"
                            >
                              <PrintIcon fontSize="small" style={{ color: '#17497F' }} />
                            </IconButton>
                          </Tooltip>
                        </CardActions>
                      </Card>
                    );
                  })}
              {filterInfo.error && (
                <Typography color="textSecondary" align="center" style={{ py: 2 }}>
                  Sem resultados encontrados
                </Typography>
              )}
              <UITablePagination
                count={filterInfo.data ? filterInfo.data.length : 0}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
              />
            </Box>
          </Hidden>
        </Grid>
      </UIContainer>
      {modalValues && categoryInfo.data && suppliersInfo.data && (
        <Dialog
          open={view}
          onClose={() => {
            handleModalUpdate();
            setModalValues(null);
          }}
          aria-labelledby="form-dialog-title"
          maxWidth="md"
          fullWidth
          fullScreen={mobile}
          classes={{ paper: classes.dialogPaper }}
        >
          <Formik
            enableReinitialize
            onSubmit={onUpdate}
            initialValues={modalValues}
            validationSchema={validationSchema}
          >
            {({ values, errors, touched, setFieldValue, submitForm }) => {
              const totalInputsCost = calculateTotalCost(values.inputs);
              const numValue = Number(values.value) || 0;
              const currentProfit = calculateProfitByValue(totalInputsCost, numValue);
              const currentMargin = parseFloat(calculateMarginByValue(totalInputsCost, numValue)) || 0;
              const currentMarkup = parseFloat(calculateMarkupByValue(totalInputsCost, numValue)) || 0;
              const isProfitPositive = currentProfit >= 0;

              return (
                <Form>
                  <UIDialogTitle
                    id="form-dialog-title"
                    onClose={() => {
                      handleModalUpdate();
                      setModalValues(null);
                    }}
                  >
                    Gerenciar Serviço: {modalValues?.name}
                  </UIDialogTitle>

                  <Box borderBottom={1} borderColor="divider" bgcolor="#fbfcfd">
                    <Tabs
                      value={modalTab}
                      onChange={(e, val) => setModalTab(val)}
                      indicatorColor="primary"
                      textColor="primary"
                      variant="fullWidth"
                    >
                      <Tab
                        className={classes.tabRoot}
                        icon={<DescriptionIcon fontSize="small" />}
                        label="Dados"
                      />
                      <Tab
                        className={classes.tabRoot}
                        icon={<MonetizationOnIcon fontSize="small" />}
                        label="Preço & Rentabilidade"
                      />
                      <Tab
                        className={classes.tabRoot}
                        icon={<LinkIcon fontSize="small" />}
                        label="Composição & Insumos"
                      />
                    </Tabs>
                  </Box>

                  <DialogContent className={classes.dialogContentStable}>
                    {/* ABA 0: DADOS DO SERVIÇO */}
                    {modalTab === 0 && (
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                          <Field
                            name="name"
                            label="Nome do Serviço"
                            error={Boolean(errors.name)}
                            helperText={touched.name && errors.name}
                            placeholder="Nome do serviço"
                            variant="outlined"
                            size="small"
                            fullWidth
                            as={TextField}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Autocomplete
                            disableClearable
                            noOptionsText="Sem opções"
                            value={
                              categoryInfo.data?.find(
                                (item) => item.id == values.category,
                              ) || null
                            }
                            disabled={categoryInfo.loading}
                            options={
                              categoryInfo.data !== null ? categoryInfo.data : []
                            }
                            getOptionLabel={(category) => category.name}
                            getOptionSelected={(option, value) => option.id == value.id}
                            onChange={(event, category) => {
                              setFieldValue('category', category && category.id);
                              if (event && event.target.value !== '' && category && category.particulars) {
                                setFieldValue(
                                  'particulars',
                                  clearObject(category.particulars, true),
                                );
                              }
                            }}
                            renderInput={(params) => (
                              <Field
                                {...params}
                                label="Categoria"
                                name="category"
                                variant="outlined"
                                size="small"
                                placeholder="Informe a categoria do serviço"
                                component={TextField}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
                            <Typography variant="body2" style={{ fontWeight: 600, color: '#333' }}>
                              Descrição para o Catálogo Virtual
                            </Typography>
                            <UIDuxiaDescriptionButton
                              itemName={values.name}
                              categoryName={
                                categoryInfo.data &&
                                categoryInfo.data.find((item) => item.id == values.category)?.name
                              }
                              itemType="serviço"
                              currentDescription={values.description}
                              onGenerated={(newDesc) => setFieldValue('description', newDesc)}
                            />
                          </Box>
                          <Field
                            name="description"
                            placeholder="Descrição detalhada do serviço..."
                            multiline
                            rows={3}
                            variant="outlined"
                            size="small"
                            fullWidth
                            as={TextField}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Autocomplete
                            disableClearable
                            noOptionsText="Sem opções"
                            value={
                              suppliersInfo.data?.find(
                                (item) => item.id === values.supplier,
                              ) || null
                            }
                            disabled={suppliersInfo.loading}
                            options={
                              suppliersInfo.data !== null ? suppliersInfo.data : []
                            }
                            getOptionLabel={(option) => {
                              if (typeof option === 'string') {
                                return option;
                              }
                              if (option.inputValue) {
                                return option.name;
                              }
                              return option.name;
                            }}
                            getOptionSelected={(option, value) => option.id === value.id}
                            filterOptions={(options, params) => {
                              const filtered = supplierFilter(options, params);
                              const existing = options.some(
                                (option) =>
                                  option.name.toLowerCase() ===
                                  params.inputValue.toLowerCase(),
                              );
                              if (params.inputValue !== '' && !existing) {
                                filtered.push({
                                  inputValue: params.inputValue,
                                  name: `Adicionar "${params.inputValue}"`,
                                });
                              }
                              return filtered;
                            }}
                            onChange={(event, newValue) => {
                              if (!newValue) {
                                setFieldValue('supplier', null);
                                return;
                              }
                              if (newValue.inputValue) {
                                setNewSupplierName(newValue.inputValue);
                                setModalSupplier(true);
                              } else {
                                setFieldValue('supplier', newValue.id);
                              }
                            }}
                            renderInput={(params) => (
                              <Field
                                {...params}
                                label="Fornecedor"
                                name="supplier"
                                variant="outlined"
                                size="small"
                                placeholder="Informe o fornecedor do serviço"
                                component={TextField}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Field
                            name="barCode"
                            label="Código do serviço / Identificador"
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <UIBarcodeRegenerateButton
                                    itemId={values.id}
                                    itemType="service"
                                    currentBarCode={values.barCode}
                                    onGenerated={(newBarCode) => {
                                      setFieldValue('barCode', newBarCode);
                                      if (modalValues) {
                                        modalValues.barCode = newBarCode;
                                      }
                                      filterLoad({ params: search || { isActive: '1' } });
                                    }}
                                  />
                                </InputAdornment>
                              ),
                            }}
                            placeholder="Código do serviço"
                            error={Boolean(errors.barCode)}
                            helperText={touched.barCode && errors.barCode}
                            variant="outlined"
                            size="small"
                            fullWidth
                            as={TextField}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={Boolean(values.show_in_catalog)}
                                onChange={(e) => setFieldValue('show_in_catalog', e.target.checked)}
                                color="primary"
                              />
                            }
                            label="Exibir no Catálogo Virtual"
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <UIImageUpload
                            images={values.images || []}
                            onChange={(newImages) => setFieldValue('images', newImages)}
                            label="Imagens do Serviço"
                            itemName={values.name}
                          />
                        </Grid>

                        {values.particulars &&
                          categoryInfo.data &&
                          (() => {
                            const selectedCat = categoryInfo.data.find(
                              (item) => item.id == values.category,
                            );
                            if (!selectedCat || !selectedCat.particulars) return null;
                            let partsObj = selectedCat.particulars;
                            if (typeof partsObj === 'string') {
                              try {
                                partsObj = JSON.parse(partsObj);
                              } catch (e) {
                                partsObj = null;
                              }
                            }
                            if (!partsObj || typeof partsObj !== 'object') return null;
                            return Object.entries(partsObj).map(([key, value]) => (
                              <Grid key={key} item xs={12} md={6}>
                                <FormControl variant="outlined" size="small" fullWidth>
                                  <InputLabel id={key}>{capitalize(key)}</InputLabel>
                                  <Field
                                    name={`particulars.${key}`}
                                    disabled={!values.category}
                                    labelId={key}
                                    label={capitalize(key)}
                                    as={Select}
                                  >
                                    <MenuItem disabled value="">
                                      <em>Informe o(a) {key}</em>
                                    </MenuItem>
                                    {typeof value === 'object'
                                      ? value.map((vl) => (
                                        <MenuItem key={vl} value={vl}>
                                          {vl}
                                        </MenuItem>
                                      ))
                                      : value && (
                                        <MenuItem key={value} value={value}>
                                          {value}
                                        </MenuItem>
                                      )}
                                  </Field>
                                </FormControl>
                              </Grid>
                            ));
                          })()}
                      </Grid>
                    )}

                    {/* ABA 1: PREÇO & RENTABILIDADE */}
                    {modalTab === 1 && (
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <Paper className={classes.metricCard} elevation={0}>
                            <Grid container spacing={2} alignItems="center">
                              <Grid item xs={12} sm={3}>
                                <Typography variant="caption" color="textSecondary" display="block">
                                  Custo Total (Insumos)
                                </Typography>
                                <Typography variant="h6" style={{ fontWeight: 'bold', color: '#475569' }}>
                                  {formattedCurrency(totalInputsCost)}
                                </Typography>
                              </Grid>
                              <Grid item xs={12} sm={3}>
                                <Typography variant="caption" color="textSecondary" display="block">
                                  Preço de Venda
                                </Typography>
                                <Typography variant="h6" style={{ fontWeight: 'bold', color: '#17497F' }}>
                                  {formattedCurrency(numValue)}
                                </Typography>
                              </Grid>
                              <Grid item xs={6} sm={3}>
                                <Typography variant="caption" color="textSecondary" display="block">
                                  Margem de Lucro
                                </Typography>
                                <Typography
                                  variant="subtitle1"
                                  className={currentMargin > 20 ? classes.marginHigh : classes.marginLow}
                                >
                                  {currentMargin.toFixed(2)} %
                                </Typography>
                              </Grid>
                              <Grid item xs={6} sm={3}>
                                <Typography variant="caption" color="textSecondary" display="block">
                                  Lucro Estimado (Unit.)
                                </Typography>
                                <span className={isProfitPositive ? classes.profitBadgePositive : classes.profitBadgeNegative}>
                                  {formattedCurrency(currentProfit)}
                                </span>
                              </Grid>
                            </Grid>
                          </Paper>
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <CurrencyTextField
                            type="tel"
                            value={totalInputsCost}
                            label="Custo Total de Insumos (R$)"
                            variant="filled"
                            size="small"
                            decimalCharacter=","
                            digitGroupSeparator="."
                            currencySymbol="R$"
                            outputFormat="string"
                            helperText="Calculado automaticamente pela soma dos insumos vinculados"
                            disabled
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <CurrencyTextField
                            type="tel"
                            value={values.value}
                            label="Preço de Venda (R$)"
                            variant="outlined"
                            size="small"
                            decimalCharacter=","
                            digitGroupSeparator="."
                            currencySymbol="R$"
                            outputFormat="string"
                            error={Boolean(errors.value)}
                            helperText={touched.value && errors.value}
                            onChange={(ev, value) => setFieldValue('value', value)}
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <CurrencyTextField
                            type="tel"
                            value={calculateMarkupByValue(totalInputsCost, values.value)}
                            label="Markup %"
                            variant="filled"
                            size="small"
                            decimalCharacter=","
                            digitGroupSeparator="."
                            currencySymbol="%"
                            outputFormat="string"
                            fullWidth
                            disabled
                          />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <CurrencyTextField
                            type="tel"
                            value={calculateMarginByValue(totalInputsCost, values.value)}
                            label="Margem %"
                            variant="outlined"
                            size="small"
                            decimalCharacter=","
                            digitGroupSeparator="."
                            currencySymbol="%"
                            outputFormat="string"
                            onBlur={(ev, value) => {
                              if (value !== undefined && value !== '') {
                                const newVal = calculateValueByMargin(totalInputsCost, value);
                                if (newVal) setFieldValue('value', newVal);
                              }
                            }}
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <CurrencyTextField
                            type="tel"
                            value={calculateProfitByValue(totalInputsCost, values.value)}
                            label="Lucro Estimado (R$)"
                            variant="filled"
                            size="small"
                            decimalCharacter=","
                            digitGroupSeparator="."
                            currencySymbol="R$"
                            outputFormat="string"
                            fullWidth
                            disabled
                          />
                        </Grid>
                      </Grid>
                    )}

                    {/* ABA 2: COMPOSIÇÃO & INSUMOS */}
                    {modalTab === 2 && (
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <Paper className={classes.metricCard} elevation={0}>
                            <Grid container spacing={2} alignItems="center">
                              <Grid item xs={12} sm={6}>
                                <Typography variant="caption" color="textSecondary" display="block">
                                  Custo Total dos Insumos
                                </Typography>
                                <Typography variant="h6" style={{ fontWeight: 'bold', color: '#17497F' }}>
                                  {formattedCurrency(totalInputsCost)}
                                </Typography>
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <Typography variant="caption" color="textSecondary" display="block">
                                  Ganho Potencial (Soma Venda dos Insumos)
                                </Typography>
                                <Typography variant="h6" style={{ fontWeight: 600, color: '#475569' }}>
                                  {formattedCurrency(calculateTotalPotentialGain(values.inputs))}
                                </Typography>
                              </Grid>
                            </Grid>
                          </Paper>
                        </Grid>

                        <Grid item xs={12}>
                          <Paper style={{ padding: '16px 20px', backgroundColor: '#fbfcfd', borderRadius: 8, border: '1px solid #e2e8f0', marginBottom: 8 }} elevation={0}>
                            <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" mb={2} style={{ gap: 8 }}>
                              <Typography variant="subtitle2" style={{ fontWeight: 600, color: '#1e293b' }}>
                                Adicionar Insumo ao Serviço
                              </Typography>
                              <Typography variant="caption" color="textSecondary" style={{ backgroundColor: '#f1f5f9', padding: '3px 8px', borderRadius: 12 }}>
                                Apenas serviços com custo (&gt; R$ 0,00) são elegíveis
                              </Typography>
                            </Box>
                            <Grid container spacing={2} alignItems="center">
                              <Grid item xs={12} sm={6}>
                                <Autocomplete
                                  size="small"
                                  options={inputOptions}
                                  getOptionLabel={(option) => {
                                    if (option.inputType === 'P') {
                                      return `${option.name} (Produto - ${formattedCurrency(option.cost)})`;
                                    }
                                    const cost = parseFloat(option.cost || 0);
                                    if (cost > 0) {
                                      return `${option.name} (Serviço - ${formattedCurrency(cost)})`;
                                    }
                                    return `${option.name} (Serviço - Sem custo - Indisponível)`;
                                  }}
                                  getOptionDisabled={(option) => option.inputType === 'S' && parseFloat(option.cost || 0) <= 0}
                                  groupBy={(option) => (option.inputType === 'P' ? 'Produtos' : 'Serviços')}
                                  value={selectedProduct}
                                  onChange={(event, newValue) => setSelectedProduct(newValue)}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      label="Buscar produto ou serviço"
                                      placeholder="Selecione o insumo..."
                                      variant="outlined"
                                      size="small"
                                      fullWidth
                                    />
                                  )}
                                />
                              </Grid>
                              <Grid item xs={6} sm={3}>
                                <TextField
                                  label="Quantidade"
                                  variant="outlined"
                                  size="small"
                                  placeholder="Ex: 1 ou 1/24"
                                  value={inputAmount}
                                  onChange={(ev) => setInputAmount(ev.target.value)}
                                  helperText={
                                    typeof inputAmount === 'string' && inputAmount.includes('/')
                                      ? `≈ ${parseFractionOrNumber(inputAmount)} un`
                                      : 'Suporta fração'
                                  }
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <Tooltip title="Calcular porção / medida">
                                          <span>
                                            <IconButton
                                              size="small"
                                              onClick={handleOpenAddCalculator}
                                              disabled={!selectedProduct}
                                              edge="end"
                                            >
                                              <TuneIcon fontSize="small" />
                                            </IconButton>
                                          </span>
                                        </Tooltip>
                                      </InputAdornment>
                                    ),
                                  }}
                                  fullWidth
                                />
                              </Grid>
                              <Grid item xs={6} sm={3}>
                                <Button
                                  variant="contained"
                                  color="primary"
                                  size="small"
                                  disableElevation
                                  fullWidth
                                  style={{ height: 40, fontWeight: 600 }}
                                  onClick={() => handleAddInput(values, setFieldValue)}
                                  disabled={!selectedProduct || parseFractionOrNumber(inputAmount) <= 0}
                                  startIcon={<AddIcon />}
                                >
                                  Adicionar
                                </Button>
                              </Grid>
                            </Grid>
                            <ServiceInputCalculatorModal
                              open={calculatorOpen}
                              onClose={() => {
                                setCalculatorOpen(false);
                                setEditingInputIndex(null);
                                setCalculatorItem(null);
                              }}
                              item={calculatorItem || selectedProduct}
                              initialAmount={editingInputIndex !== null && values.inputs[editingInputIndex] ? values.inputs[editingInputIndex].amount : inputAmount}
                              isEditing={editingInputIndex !== null}
                              onApply={(val) => handleApplyCalculator(val, values, setFieldValue)}
                            />
                          </Paper>
                        </Grid>

                        {values.inputs && values.inputs.length > 0 && (
                          <Grid item xs={12}>
                            {/* Desktop Table View */}
                            <Hidden smDown>
                              <TableContainer component={Paper} variant="outlined" style={{ marginTop: 8 }}>
                                <Table size="small">
                                  <TableHead>
                                    <TableRow style={{ backgroundColor: '#fafafa' }}>
                                      <TableCell style={{ fontWeight: 600 }}>Insumo</TableCell>
                                      <TableCell style={{ fontWeight: 600 }} align="center">Tipo</TableCell>
                                      <TableCell style={{ fontWeight: 600 }} align="center">Qtd</TableCell>
                                      <TableCell style={{ fontWeight: 600 }} align="right">Custo Unit.</TableCell>
                                      <TableCell style={{ fontWeight: 600 }} align="right">Venda Unit.</TableCell>
                                      <TableCell style={{ fontWeight: 600 }} align="right">Subtotal Custo</TableCell>
                                      <TableCell style={{ fontWeight: 600 }} align="center">Ações</TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {values.inputs.map((input, index) => {
                                      const unitCost = getInputCost(input);
                                      const unitValue = getInputValue(input);
                                      const type = getInputType(input);
                                      return (
                                        <TableRow key={index} hover>
                                          <TableCell>{getInputName(input)}</TableCell>
                                          <TableCell align="center">
                                            <Chip
                                              size="small"
                                              label={type === 'P' ? 'Produto' : 'Serviço'}
                                              style={{
                                                backgroundColor: type === 'P' ? '#e3f2fd' : '#f3e5f5',
                                                color: type === 'P' ? '#1565c0' : '#7b1fa2',
                                                fontWeight: 500,
                                              }}
                                            />
                                          </TableCell>
                                          <TableCell align="center">
                                            {editingIndex === index ? (
                                              <TextField
                                                value={editingAmount}
                                                onChange={(ev) => setEditingAmount(ev.target.value)}
                                                onBlur={() => {
                                                  const parsed = parseFractionOrNumber(editingAmount);
                                                  if (parsed > 0) {
                                                    const newInputs = values.inputs.map((item, i) =>
                                                      i === index ? { ...item, amount: parsed } : item
                                                    );
                                                    setFieldValue('inputs', newInputs);
                                                  }
                                                  setEditingIndex(null);
                                                  setEditingAmount(0);
                                                }}
                                                onKeyDown={(ev) => {
                                                  if (ev.key === 'Enter') {
                                                    const parsed = parseFractionOrNumber(editingAmount);
                                                    if (parsed > 0) {
                                                      const newInputs = values.inputs.map((item, i) =>
                                                        i === index ? { ...item, amount: parsed } : item
                                                      );
                                                      setFieldValue('inputs', newInputs);
                                                    }
                                                    setEditingIndex(null);
                                                    setEditingAmount(0);
                                                  }
                                                }}
                                                inputProps={{ style: { textAlign: 'center', width: 70 } }}
                                                placeholder="1/24"
                                                autoFocus
                                                size="small"
                                              />
                                            ) : (
                                              <span>{parseFloat(input.amount)}</span>
                                            )}
                                          </TableCell>
                                          <TableCell align="right">{formattedCurrency(unitCost)}</TableCell>
                                          <TableCell align="right" style={{ color: '#666' }}>{formattedCurrency(unitValue)}</TableCell>
                                          <TableCell align="right" style={{ fontWeight: 500 }}>{formattedCurrency(unitCost * parseFloat(input.amount))}</TableCell>
                                          <TableCell align="center">
                                            {editingIndex !== index && (
                                              <Tooltip title="Editar quantidade">
                                                <IconButton size="small" onClick={() => handleOpenEditInputModal(index, input)}>
                                                  <EditIcon fontSize="small" />
                                                </IconButton>
                                              </Tooltip>
                                            )}
                                            <Tooltip title="Remover insumo">
                                              <IconButton size="small" onClick={() => {
                                                const newInputs = values.inputs.filter((_, i) => i !== index);
                                                setFieldValue('inputs', newInputs);
                                              }}>
                                                <DeleteIcon fontSize="small" color="error" />
                                              </IconButton>
                                            </Tooltip>
                                          </TableCell>
                                        </TableRow>
                                      );
                                    })}
                                    <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                                      <TableCell colSpan={5} align="right" style={{ fontWeight: 600 }}>Total de Insumos (Custo)</TableCell>
                                      <TableCell align="right" style={{ fontWeight: 700 }}>{formattedCurrency(calculateTotalCost(values.inputs))}</TableCell>
                                      <TableCell />
                                    </TableRow>
                                    <TableRow style={{ backgroundColor: '#fafafa' }}>
                                      <TableCell colSpan={5} align="right" style={{ color: '#757575', fontSize: '0.85rem' }}>
                                        Ganho Potencial (Soma Venda)
                                      </TableCell>
                                      <TableCell align="right" style={{ color: '#757575', fontSize: '0.85rem', fontWeight: 500 }}>
                                        {formattedCurrency(calculateTotalPotentialGain(values.inputs))}
                                      </TableCell>
                                      <TableCell />
                                    </TableRow>
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </Hidden>

                            {/* Mobile Cards View */}
                            <Hidden mdUp>
                              <Box style={{ width: '100%', marginTop: 8 }}>
                                {values.inputs.map((input, index) => {
                                  const unitCost = getInputCost(input);
                                  const unitValue = getInputValue(input);
                                  const type = getInputType(input);
                                  return (
                                    <Card
                                      key={index}
                                      variant="outlined"
                                      style={{
                                        marginBottom: 8,
                                        borderLeft: `4px solid ${type === 'P' ? '#1565c0' : '#7b1fa2'}`,
                                        borderRadius: 8,
                                        backgroundColor: '#FFFFFF',
                                      }}
                                    >
                                      <CardContent style={{ padding: 12, paddingBottom: 12 }}>
                                        <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                                          <Typography variant="subtitle2" style={{ fontWeight: 'bold' }}>
                                            {getInputName(input)}
                                          </Typography>
                                          <Box display="flex" alignItems="center">
                                            <Chip
                                              size="small"
                                              label={type === 'P' ? 'Produto' : 'Serviço'}
                                              style={{
                                                backgroundColor: type === 'P' ? '#e3f2fd' : '#f3e5f5',
                                                color: type === 'P' ? '#1565c0' : '#7b1fa2',
                                                fontWeight: 500,
                                                marginRight: 4,
                                              }}
                                            />
                                            <IconButton size="small" onClick={() => {
                                              const newInputs = values.inputs.filter((_, i) => i !== index);
                                              setFieldValue('inputs', newInputs);
                                            }}>
                                              <DeleteIcon fontSize="small" color="error" />
                                            </IconButton>
                                          </Box>
                                        </Box>
                                        <Grid container spacing={1} alignItems="center">
                                          <Grid item xs={4}>
                                            <Typography variant="caption" color="textSecondary" display="block">
                                              Qtd
                                            </Typography>
                                            {editingIndex === index ? (
                                              <TextField
                                                type="number"
                                                value={editingAmount}
                                                onChange={(ev) => setEditingAmount(ev.target.value)}
                                                onBlur={() => {
                                                  if (editingAmount > 0) {
                                                    const newInputs = values.inputs.map((item, i) =>
                                                      i === index ? { ...item, amount: parseFloat(editingAmount) } : item
                                                    );
                                                    setFieldValue('inputs', newInputs);
                                                  }
                                                  setEditingIndex(null);
                                                  setEditingAmount(0);
                                                }}
                                                onKeyDown={(ev) => {
                                                  if (ev.key === 'Enter') {
                                                    if (editingAmount > 0) {
                                                      const newInputs = values.inputs.map((item, i) =>
                                                        i === index ? { ...item, amount: parseFloat(editingAmount) } : item
                                                      );
                                                      setFieldValue('inputs', newInputs);
                                                    }
                                                    setEditingIndex(null);
                                                    setEditingAmount(0);
                                                  }
                                                }}
                                                inputProps={{ min: 0.01, step: 0.01, style: { width: 50, textAlign: 'center' } }}
                                                autoFocus
                                                size="small"
                                              />
                                            ) : (
                                              <Box display="flex" alignItems="center">
                                                <Typography variant="body2" style={{ fontWeight: 500, marginRight: 4 }}>
                                                  {parseFloat(input.amount)}
                                                </Typography>
                                                <IconButton size="small" onClick={() => handleOpenEditInputModal(index, input)}>
                                                  <EditIcon style={{ fontSize: 16 }} />
                                                </IconButton>
                                              </Box>
                                            )}
                                          </Grid>
                                          <Grid item xs={4}>
                                            <Typography variant="caption" color="textSecondary" display="block">
                                              Custo Unit.
                                            </Typography>
                                            <Typography variant="body2">
                                              {formattedCurrency(unitCost)}
                                            </Typography>
                                          </Grid>
                                          <Grid item xs={4}>
                                            <Typography variant="caption" color="textSecondary" display="block">
                                              Venda Unit.
                                            </Typography>
                                            <Typography variant="body2" style={{ color: '#666' }}>
                                              {formattedCurrency(unitValue)}
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                        <Box display="flex" justifyContent="space-between" mt={1} pt={1} borderTop="1px dashed #eee">
                                          <Typography variant="caption" style={{ fontWeight: 600 }}>
                                            Subtotal Custo:
                                          </Typography>
                                          <Typography variant="caption" style={{ fontWeight: 700 }}>
                                            {formattedCurrency(unitCost * parseFloat(input.amount))}
                                          </Typography>
                                        </Box>
                                      </CardContent>
                                    </Card>
                                  );
                                })}
                                <Paper variant="outlined" style={{ padding: 12, backgroundColor: '#f9f9f9', borderRadius: 8, marginTop: 8 }}>
                                  <Box display="flex" justifyContent="space-between" alignItems="center">
                                    <Typography variant="body2" style={{ fontWeight: 600 }}>
                                      Total de Insumos (Custo):
                                    </Typography>
                                    <Typography variant="body1" style={{ fontWeight: 700 }}>
                                      {formattedCurrency(calculateTotalCost(values.inputs))}
                                    </Typography>
                                  </Box>
                                  <Box display="flex" justifyContent="space-between" alignItems="center" mt={0.5}>
                                    <Typography variant="caption" color="textSecondary">
                                      Ganho Potencial (Soma Venda):
                                    </Typography>
                                    <Typography variant="caption" color="textSecondary" style={{ fontWeight: 500 }}>
                                      {formattedCurrency(calculateTotalPotentialGain(values.inputs))}
                                    </Typography>
                                  </Box>
                                </Paper>
                              </Box>
                            </Hidden>
                          </Grid>
                        )}
                        {(!values.inputs || values.inputs.length === 0) && (
                          <Grid item xs={12}>
                            <Box p={3} textAlign="center" bgcolor="grey.50" borderRadius={8} border="1px dashed #ccc" mt={1}>
                              <Typography variant="body2" color="textSecondary">Nenhum insumo vinculado. Use o campo acima para adicionar produtos ou serviços.</Typography>
                            </Box>
                          </Grid>
                        )}
                      </Grid>
                    )}
                  </DialogContent>

                  <DialogActions style={{ padding: '12px 24px', backgroundColor: '#fbfcfd', borderTop: '1px solid #e0e0e0' }}>
                    <Button
                      onClick={() => setPrintSingleProduct(values)}
                      color="primary"
                      variant="outlined"
                      startIcon={<PrintIcon />}
                      style={{ marginRight: 'auto' }}
                    >
                      Imprimir Etiqueta
                    </Button>
                    <Button onClick={() => { handleModalUpdate(); setModalValues(null); }}>
                      Cancelar
                    </Button>
                    <Button
                      onClick={() => submitForm()}
                      color="primary"
                      variant="contained"
                      disableElevation
                    >
                      Salvar Alterações
                    </Button>
                  </DialogActions>

                  <SupplierCreateModal
                    open={modalSupplier}
                    initialName={newSupplierName}
                    onClose={() => setModalSupplier(false)}
                    onSuccess={(newSupplier) => {
                      suppliersLoad();
                      setFieldValue('supplier', newSupplier.id);
                      setModalSupplier(false);
                    }}
                  />
                </Form>
              );
            }}
          </Formik>
        </Dialog>
      )}

      <Dialog open={changeActive} onClose={() => setChangeActive(false)}>
        <UIDialogTitle id="alert-dialog-title">
          Deseja tornar o serviço{' '}
          {Number(modalValues?.isActive) === 1 ? 'indisponível' : 'disponível'} ?
        </UIDialogTitle>
        <DialogActions>
          <Button onClick={() => setChangeActive(false)} color="primary">
            Não
          </Button>
          <Button onClick={() => onActive()} color="primary" autoFocus>
            Sim
          </Button>
        </DialogActions>
      </Dialog>

      <UIDialogConfirm
        open={alert}
        close={() => setAlert(false)}
        data={activeInfo}
        setrequestinfo={setActiveInfo}
        messageSucess={
          activeInfo.data?.message ||
          `Serviço ${
            Number(modalValues?.isActive) === 1 ? 'desativado' : 'ativado'
          } com sucesso!`
        }
        messageError="Ops, ocorreu um erro ao manipular o serviço"
      />

      <UIDialogConfirm
        open={alert}
        close={() => setAlert(false)}
        data={updateInfo}
        setrequestinfo={closeAlert}
        messageSucess={
          updateInfo.data
            ? updateInfo.data.message
            : 'Serviço atualizado com sucesso'
        }
        type="success"
      />

      <ProductSinglePrintModal
        open={Boolean(printSingleProduct)}
        product={printSingleProduct}
        handleClose={() => setPrintSingleProduct(null)}
      />
      <CategoryBulkPrintModal
        open={bulkPrintModal}
        handleClose={() => {
          setBulkPrintModal(false);
          setBulkPrintItems(null);
        }}
        referenceType="s"
        initialItems={bulkPrintItems}
      />
      <UIBatchActionBar
        selectedCount={selectedIds.length}
        totalCount={filterInfo.data ? filterInfo.data.length : 0}
        onClearSelection={() => setSelectedIds([])}
        onSelectAll={handleSelectAll}
        onCatalogVisibility={handleBatchCatalogVisibility}
        onPrintLabels={handleBatchPrintLabels}
        onDeactivate={handleBatchDeactivate}
        selectedItems={filterInfo.data ? filterInfo.data.filter((s) => selectedIds.includes(s.id)) : []}
        loading={activeInfo.loading || updateInfo.loading}
        itemLabel="serviços"
      />
    </>
  );
};

export default ServiceSearch;